import { render } from "./update-module.vue?vue&type=template&id=d012a2ce&scoped=true"
import script from "./update-module.vue?vue&type=script&lang=js"
export * from "./update-module.vue?vue&type=script&lang=js"

import "./update-module.vue?vue&type=style&index=0&id=d012a2ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d012a2ce"],['__file',"src/components/applications/module/update-module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d012a2ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d012a2ce', __exports__)) {
    api.reload('d012a2ce', __exports__)
  }
  
  module.hot.accept("./update-module.vue?vue&type=template&id=d012a2ce&scoped=true", () => {
    api.rerender('d012a2ce', render)
  })

}


export default __exports__